import { ArticleStream } from '@/network/api/stream'
import { Avatar, Box, Paper, Typography, Link, Stack } from '@mui/material'
import { TimeIcon } from '@mui/x-date-pickers'
import moment from 'moment'
// import SentimentIcon from '../SentimentIcon'

interface Props {
  item: ArticleStream
  isLocked?: boolean
}

const OnmStreamCard = ({ item, isLocked = false }: Props) => {
  return (
    <Paper
      variant="outlined"
      key={item.originalId}
      sx={{
        p: 2,
        mt: 2,
        borderRadius: 3,
        ...(isLocked ? { filter: 'blur(8px)', transition: 'filter 0.3s ease-in-out' } : {}),
      }}
    >
      <Box display={'flex'} mt={0.5} gap={1}>
        <Box>
          <Typography fontWeight={700} fontSize={{ xs: 12, sm: 13 }} color={'rgba(89, 89, 89, 1)'}>
            {item.sourceName}
          </Typography>
        </Box>
        {/* <SentimentIcon item={item.sentiment} /> */}
      </Box>
      <Box display={'flex'} alignItems={'flex-start'} mt={1} py={1}>
        <Box display={'flex'} alignItems={'center'}>
          <Avatar variant="square" src={item.displayPicture} sx={{ width: '50px', height: '50px' }} />
          <Box px={2}>
            <Typography fontWeight={700} fontSize={12} variant="h6">
              {item.title}
            </Typography>
            <Typography
              fontWeight={400}
              fontSize={{ xs: 12, sm: 13 }}
              color={'rgba(89, 89, 89, 1)'}
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {item.content}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box display={'flex'} alignItems={'center'} justifyContent="space-between" gap={1}>
        <Stack direction="row" alignItems="center" gap={1}>
          <TimeIcon />
          <Typography fontSize={10} fontWeight={400} color={'rgba(157, 157, 156, 1)'}>
            {moment(item.datePublished).format('DD MMM YYYY | hh:mm A')}
          </Typography>
        </Stack>
        <Link variant="body2" href={item.link}>
          Link to source
        </Link>
      </Box>
      <Box></Box>
    </Paper>
  )
}

export default OnmStreamCard
